import React from 'react';
import { motion } from 'framer-motion';

const AdminStatCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  change,
  changeType = 'neutral', // 'positive', 'negative', 'neutral'
  trend, // 'up', 'down', 'stable'
  color = 'blue',
  onClick,
  className = ''
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={onClick ? { scale: 1.02, y: -2 } : {}}
      onClick={onClick}
      className={`admin-stat-card ${onClick ? 'admin-stat-card-clickable' : ''} ${className}`}
    >
      <div className="admin-stat-card-header">
        {Icon && (
          <div className={`admin-stat-icon admin-stat-icon-${color}`}>
            <Icon className="admin-stat-icon-svg" />
          </div>
        )}
        {change && (
          <div className={`admin-stat-change admin-stat-change-${changeType}`}>
            {change}
          </div>
        )}
      </div>
      
      <div className="admin-stat-card-body">
        <div className="admin-stat-value">{value}</div>
        <div className="admin-stat-label">{title}</div>
        {subtitle && <div className="admin-stat-subtitle">{subtitle}</div>}
      </div>
    </motion.div>
  );
};

export default AdminStatCard;

